import * as tslib_1 from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { getUserList, removeStudent, changeStudentCourse } from '@/api/student';
import { mixin_export } from '@/utils/exportFile';
let Login = class Login extends Vue {
    constructor() {
        super(...arguments);
        this.search = {
            type: '-1',
            courseId: '',
            keywordType: '1',
            keyword: '',
            status: '-1',
        };
        this.tableData = [];
        this.pageNo = 1;
        this.pageSize = 15;
        this.total = 0;
        this.columnList = [];
        this.isShowAdd = false;
        this.form = {
            type: '',
            courseName: '',
            courseId: '',
            userId: '',
            id: ''
        };
    }
    created() {
        if (this.$route.query.id) {
            this.search.courseId = this.$route.query.id;
            this.getList();
        }
    }
    onSearch() {
        this.pageNo = 1;
        this.getList();
    }
    async getList() {
        let data = {
            type: this.search.type,
            courseId: this.search.courseId,
            keywordType: this.search.keywordType,
            keyword: this.search.keyword,
            status: this.search.status,
            pageSize: this.pageSize,
            pageNo: this.pageNo
        };
        let res = await getUserList(data);
        if (res.data.status !== 200)
            return this.$message.error(res.data.msg);
        this.tableData = res.data.data.list || [];
        this.pageNo = Number(res.data.data.pageNum);
        this.total = Number(res.data.data.total);
    }
    changePage(pageNo) {
        this.pageNo = pageNo;
        this.getList();
    }
    changePageSize(pageSize) {
        this.pageSize = pageSize;
        this.getList();
    }
    handleClickTabs(tabs) {
        this.search.type = tabs.name;
        if (this.search.type == '') {
            this.search.courseId = '';
        }
        this.onSearch();
    }
    onExport() {
        this.$confirm('是否确认导出？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            let data = {
                type: this.search.type,
                courseId: this.search.type == '1' ? this.search.courseId[1] : this.search.courseId,
                keywordType: this.search.keywordType,
                keyword: this.search.keyword,
                status: this.search.status,
            };
            mixin_export('/courseAdmin/user/selfResearch/export', 'post', data);
        }).catch(() => {
            this.$message({
                type: 'info',
                message: '已取消'
            });
        });
    }
    onAdd() {
        this.$router.push({ path: '/student-manager/add', query: {
                courseId: this.search.courseId
            } });
    }
    onJump(props) {
        this.$router.push({ path: '/course-manager/progressList', query: {
                courseId: props.courseId,
                userId: props.userId,
                courseType: props.courseType
            } });
    }
    onDel(props) {
        this.$confirm('是否移除该学员', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(async () => {
            let data = {
                id: props.id,
                userId: props.userId,
                courseId: props.courseId
            };
            let res = await removeStudent(data);
            if (res.data.status !== 200)
                return this.$message.error(res.data.msg);
            this.$message({
                type: 'success',
                message: '已移除'
            });
            this.getList();
        }).catch(() => {
            this.$message({
                type: 'info',
                message: '已取消'
            });
        });
    }
    onChangeClass(props) {
        this.form.id = props.id;
        this.form.userId = props.userId;
        // this.form.courseId = props.courseId;
        this.form.courseName = props.courseName;
        this.form.type = props.courseType;
        this.isShowAdd = true;
    }
    handleClose() {
        this.isShowAdd = false;
        this.form.id = '';
        this.form.userId = '';
        this.form.courseId = '';
        this.form.courseName = '';
        this.form.type = '';
    }
    async onSubmit() {
        if (!this.form.courseId || this.form.courseId.length == 0) {
            return this.$message.error(`请选择${this.form.type == 1 ? '训练营' : '专栏'}`);
        }
        let data = {
            id: this.form.id,
            userId: this.form.userId,
            courseId: this.form.type == 1 ? this.form.courseId[1] : this.form.courseId,
        };
        const res = await changeStudentCourse(data);
        if (res.data.status !== 200)
            return this.$message.error(res.data.msg);
        this.$message({
            type: 'success',
            message: '调整成功'
        });
        this.getList();
    }
};
Login = tslib_1.__decorate([
    Component({
        filters: {
            formatJoinType(type) {
                //加入类型 1：订单生成；2：初始化导入；3：手动添加(导入)； 4：活动领取（兑换码）
                if (type == 1)
                    return '订单生成';
                if (type == 2)
                    return '初始化导入';
                if (type == 3)
                    return '手动添加(导入)';
                if (type == 4)
                    return '活动领取(兑换码)';
            }
        }
    })
], Login);
export default Login;
